/**
 * Formats phone numbers with international prefix
 * - Adds "+" prefix for numbers longer than 10 digits that start with country code (e.g., 91)
 * - Adds "+" prefix for other international numbers (>10 digits)
 * - Returns the number as-is for domestic numbers (<=10 digits)
 *
 * @param phoneNumber - The phone number to format
 * @returns Formatted phone number with + prefix if applicable
 */
export const formatPhoneNumber = (phoneNumber: string | number | null | undefined): string => {
  // Handle null, undefined, or empty values
  if (!phoneNumber) {
    return '';
  }

  // Convert to string and remove any existing + prefix and spaces
  const cleanNumber = String(phoneNumber).trim().replace(/^\+/, '').replace(/\s/g, '');

  // If number is empty after cleaning, return empty string
  if (!cleanNumber) {
    return '';
  }

  // If number has more than 10 digits, it's an international number
  if (cleanNumber.length > 10) {
    return `+${cleanNumber}`;
  }

  // Otherwise return as-is (domestic number)
  return cleanNumber;
};
